import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { BusinessFunctionService } from "../services/businessfunction.service";
import { Observable } from "rxjs";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Injectable()
export class BusinessFunctionResolver implements Resolve<IBusinessFunction> {

    constructor(private businessFunctionService: BusinessFunctionService, private readonly store: Store<IAppStore>) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IBusinessFunction> {
        let businessFunctionId: number = 0;
        this.store.select(e => e.user.selectedBusinessFunction)
            .subscribe(e => businessFunctionId = e.id);
        if (!businessFunctionId) {
            return null;
        }
        return this.businessFunctionService.getBusinessFunction(businessFunctionId);
    }
}
